import { createDraftSafeSelector, type PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import { produce } from "immer";
import type { EmailFtpSettingsState } from "Interfaces";

const initialState: EmailFtpSettingsState = {
	emailServerSettings: {
		server: "smtp-mail.outlook.com",
		port: 25,
		security: "OFF",
		user: "username842@outlook.com",
		testEmailAddress: "testname@clintonelectronics.com"
	},
	emailListSettings: {
		emailList: [
			"test@email.com",
			"test2@email.com",
			"test3@email.com"
		],
		minimumEmailFrequency: 1,
		includeSnapshotOption: true,
		presetSchedule: {
			always: true,
			weekday: false,
			weekend: false
		}
	},
	ftpServerSettings: {
		receiver: "",
		host: "",
		port: 21,
		basePath: "",
		idPassRequired: false,
		id: "",
		frequency: 0,
		log: false,
		filePrefix: "",
		schedule: {
			always: false,
			weekday: false,
			weekend: false
		}
	}
};

const setEmailFtpSettingsReducer = (state: EmailFtpSettingsState, action: PayloadAction<EmailFtpSettingsState>) => {
	return produce(action.payload, draft => {
		delete draft.emailServerSettings.password;
		delete draft.ftpServerSettings.password;
	});
};

const getEmailFtpSettings = (state: EmailFtpSettingsState) => {
	return produce(state, draft => {
		draft.emailServerSettings.password = "";
		draft.ftpServerSettings.password = "";
	});
};

const emailFtpSlice = createAppSlice({
	initialState,
	name: "emailFtp",
	reducers: {
		setEmailFtpSettingsAction: setEmailFtpSettingsReducer
	},
	selectors: {
		selectEmailFtpSettings: createDraftSafeSelector(
			(state) => state,
			getEmailFtpSettings
		)
	}
});

export default emailFtpSlice;

export const { setEmailFtpSettingsAction } = emailFtpSlice.actions;
export const { selectEmailFtpSettings } = emailFtpSlice.selectors;
